import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";
import { useConsent } from "@/context/ConsentContext";

/**
 * Automatically tracks page-view events on every route change,
 * but ONLY when the user has granted consent.
 * Mounted once inside <AppRouter />.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const { status } = useConsent();

  useEffect(() => {
    if (status !== "granted") return;
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search, status]);

  return null;
}
